// src/components/Bookings/BookingCancelled.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// A esta pantalla llega el usuario si cierra Stripe Checkout sin pagar, o si
// el pago fue rechazado. El booking sigue existiendo en tu DB con
// status "pending" - no se perdió nada, solo no se ha pagado todavía.
const BookingCancelled = () => {
  const { t } = useTranslation('common');

  return (
    <div className="bg-[#EFE6DD] min-h-screen flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl border border-[#3A2A20]/10 overflow-hidden text-center">
        {/* Imagen clickeable */}
        <Link to="/my-bookings" className="block group">
          <div className="h-48 overflow-hidden">
            <img
              src="https://res.cloudinary.com/dc6xthiol/image/upload/v1766032270/HP4_g9jbfq.jpg"
              alt={t('bookingCancelled.imageAlt')}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Link>

        <div className="p-8">
          {/* Badge de "no completado" */}
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#9A0002]/10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              className="h-7 w-7 text-[#9A0002]"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9A0002]">
            {t('bookingCancelled.eyebrow')}
          </span>
          <h1 className="mt-2 font-['Fraunces'] text-2xl sm:text-3xl font-semibold text-[#3A2A20]">
            {t('bookingCancelled.title')}
          </h1>
          <p className="text-[#3A2A20]/70 text-sm mt-3 leading-relaxed">
            {t('bookingCancelled.message')}
          </p>

          <Link
            to="/my-bookings"
            className="mt-6 inline-block w-full px-6 py-3.5 bg-[#9A0002] hover:bg-[#7A0001] text-[#EFE6DD] rounded-xl text-sm font-medium transition"
          >
            {t('bookingCancelled.viewPending')}
          </Link>
          <Link
            to="/rooms"
            className="mt-3 inline-block w-full px-6 py-3.5 border border-[#3A2A20]/20 rounded-xl text-[#3A2A20] hover:bg-[#3A2A20]/5 transition text-sm font-medium"
          >
            {t('bookingCancelled.newBooking')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingCancelled;
